import React from "react";
import { Flex, SVGButton, Modal } from "/app/src/component";
const WrapperStyle = {
  dataName: "ModalWrapperStyle",
  column: true,
  hAlignContent: "center",
  my: "25px",
  width: "100%",
};
const ModalBodyTextStyle = {
  color: "#404040",
  fontSize: "24px",
  textAlign: "center",
  marginBottom: "20px",
};

const ReturnButtonStyle = {
  src: "/images/Return.svg",
  text: "Avbryt",
  border: true,
  hover: "blue",
  mr: "20px",
};

const RemoveButtonStyle = {
  src: "/images/Trash.svg",
  text: "Ta bort",
  border: true,
  hover: "red",
};

const RemoveItemModal = ({ title, open, onClose, text, onRemoveClick }) => {
  const ModalProps = {
    title: title,
    open: open,
    onClose: onClose,
  };

  /*
    Ta bort fråga
    Är du säker på att du vill ta bort frågan? All feedback till frågan kommer
    att tas bort. Detta går inte att ångra.
    */
  return (
    <Modal {...ModalProps}>
      <Flex {...WrapperStyle}>
        <Flex {...ModalBodyTextStyle}> {text} </Flex>
        <Flex row>
          <SVGButton {...ReturnButtonStyle} onClick={() => onClose()} />
          <SVGButton
            {...RemoveButtonStyle}
            onClick={() => {
              onRemoveClick();
              onClose();
            }}
          />
        </Flex>
      </Flex>
    </Modal>
  );
};
export default RemoveItemModal;



// WEBPACK FOOTER //
// ./src/component/Modal/RemoveItemModal.js